export enum AuthenticationRoutesAPI {
  INFORMATION = '/customer-portal-service/auth/Information',
  REFRESH = '/customer-portal-service/public/auth/Tokens',
  REVOKE = '/customer-portal-service/public/auth/Revoke',
}
